import { MimeTypes } from "./MimeTypes";

export class WadoRsProxy {
  public _baseUrl: string = "";

  // constructor(baseUrl: string = null) {
  constructor() {
    this._baseUrl = "http://3.37.183.89:8080/dcm4chee-arc/aets/DCM4CHEE/rs";
  }

  public get BaseUrl() {
    return this._baseUrl;
  }

  public set BaseUrl(value: string) {
    this._baseUrl = value;
  }

  public async getStudy(studyInstanceUid: string, mediaType: string) {
    return await this.getBinaryDICOMMultipart(
      "/studies/" + studyInstanceUid + "/",
      mediaType
    );
  }

  public getSeries(studyInstanceUid: string, mediaType: string) {
    return this.getMultipart(
      "/studies/" + studyInstanceUid + "/" + "series" + "/",
      mediaType
    );
  }
  public getSeriesMetadata(
    studyInstanceUid: string,
    seriesInstanceUid: string,
    mediaType: string = "application/json"
  ) {
    var urlParts =
      "/studies/" +
      studyInstanceUid +
      "/series/" +
      seriesInstanceUid +
      "/metadata";

    return this.getMetadata(urlParts, mediaType);
  }

  public getInstances(
    studyInstanceUid: string,
    seriesInstanceUid: string,
    mediaType: string = "application/json"
  ) {
    return this.getMultipart(
      "/studies/" +
        studyInstanceUid +
        "/series/" +
        seriesInstanceUid +
        "/instances",
      mediaType
    );
  }

  public async getObjectInstance(
    studyInstanceUid: string,
    seriesInstanceUid: string,
    sopInstanceUID: string,
    mediaType: string
  ) {
    return await this.getBinaryDICOMMultipart(
      "/studies/" +
        studyInstanceUid +
        "/series/" +
        seriesInstanceUid +
        "/instances/" +
        sopInstanceUID +
        "/",
      mediaType
    );
  }

  public getBinaryDICOMMultipart(urlRsPart: string, acceptDataType: string) {
    return new Promise((resolve, reject) => {
      // var deffered = $.Deferred();
      var url = this.BaseUrl + urlRsPart;
      var xhr = new XMLHttpRequest();
      var acceptHeader = MimeTypes.getMultiPartAcceptHeader(acceptDataType);

      xhr.overrideMimeType("application/octet-stream");
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer";
      // xhr.setRequestHeader("accept", acceptHeader);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          // Fire event
          //listener.onDataReceived(new Uint8Array(xhr.response));
          var buffer = new Uint8Array(xhr.response);

          resolve(buffer);
        }
      };
      xhr.onerror = function (error) {
        reject(error);
      };

      // if (DICOMwebJS.ServerConfiguration.IncludeAuthorizationHeader) {
      //   xhr.setRequestHeader(
      //     "Authorization",
      //     DICOMwebJS.ServerConfiguration.SecurityToken
      //   );
      // }

      xhr.send(null);
      // return deffered.promise();
    });
  }

  public getMultipart(urlRsPart: string, acceptDataType: string) {
    return this.get(
      urlRsPart,
      MimeTypes.getMultiPartAcceptHeader(acceptDataType)
      // transferSyntax
    );
  }

  public get(urlRsPart: string, acceptHeader: string) {
    // var deffered = $.Deferred();
    return new Promise((resolve, reject) => {
      var url = this.BaseUrl + urlRsPart;
      var xhr = new XMLHttpRequest();

      // if (transferSyntax) {
      //   acceptHeader += ";transfer-syntax=" + transferSyntax;
      // }

      xhr.open("GET", url, true);
      // xhr.setRequestHeader("accept", acceptHeader);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          resolve(xhr.response);
        }
      };
      xhr.onerror = function (error) {
        reject(error);
      };

      // if (DICOMwebJS.ServerConfiguration.IncludeAuthorizationHeader) {
      //   xhr.setRequestHeader(
      //     "Authorization",
      //     DICOMwebJS.ServerConfiguration.SecurityToken
      //   );
      // }

      xhr.send(null);
    });
  }
  public getMetadata(urlParts: string, mediaType: string = "application/json") {
    if (mediaType === null || typeof mediaType === "undefined") {
      mediaType = MimeTypes.Json;
    }

    if (mediaType == MimeTypes.Json) {
      return this.get(urlParts, mediaType);
    } else if (mediaType == MimeTypes.xmlDicom) {
      return this.getMultipart(urlParts, mediaType);
    } else {
      throw "Invalid mediaType for metadata request";
    }
  }
}
